/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ImpersonationTokenOutputDto interface.
 */
export function instanceOfImpersonationTokenOutputDto(value) {
    return true;
}
export function ImpersonationTokenOutputDtoFromJSON(json) {
    return ImpersonationTokenOutputDtoFromJSONTyped(json, false);
}
export function ImpersonationTokenOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'] == null ? undefined : json['token'],
    };
}
export function ImpersonationTokenOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
    };
}
